import { PractitionerCreateDailyMainDiagnosisStatisticsCommand } from '@dreryk/egabinet-statistics-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ModalConfirmButton } from '@dreryk/react-components';
import { Range } from '@dreryk/watermelon';

import { statisticsTranslationKeys } from '../../../translations';
import { GenerateStatisticsFormBean } from '../GenerateStatisticsForm.types';
import { GenerateStatisticsModalConfirmButtonProps } from '../GenerateStatisticsModalConfirmButtonSwitch';

export const GeneratePractitionerDailyMainDiagnosisStatisticsButton = (
   props: GenerateStatisticsModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: createStatistics } = useCqrsCommand<void, GenerateStatisticsFormBean>(
      (parameters) => {
         const command = new PractitionerCreateDailyMainDiagnosisStatisticsCommand();
         command.dateRange = Range.closed(parameters.from, parameters.to);
         return command;
      },
      {
         onSuccess: () => {
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         label={statisticsTranslationKeys.modal.submit}
         onClick={props.handleSubmit(createStatistics)}
      />
   );
};
